import React, { useRef, useEffect } from 'react';
import { handleBalanceKeyDown, formatBalanceValue } from '../../../utilities/balanceUtils';


const InlineBalanceEdit = ({ 
  recordId, 
  defaultValue, 
  isValueChanged, 
  submitting, 
  onInputChange, 
  onSave, 
  onCancel 
}) => {
  const editInputRef = useRef(null);

  useEffect(() => {
    if (editInputRef.current) {
      editInputRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e) => {
    handleBalanceKeyDown(e);
    
    // Submit on  if valid
    if (e.key === 'Enter' && isValueChanged && !submitting) {
      onSave(recordId, editInputRef.current.value);
    }
  };

  const handleChange = (e) => {
    onInputChange(e);
    
    const formattedValue = formatBalanceValue(e.target.value);
    if (formattedValue !== e.target.value) {
      e.target.value = formattedValue;
    }
  };

  return (
    <div className="employee-balance-inline-edit">
      <input 
        type="number" 
        min="0"
        max="99.99"
        step="0.01"
        defaultValue={defaultValue}
        className="employee-balance-edit-input"
        ref={editInputRef}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      <div className="employee-balance-edit-actions">
        <button 
          className={`employee-balance-save-btn ${!isValueChanged ? 'disabled' : ''}`}
          onClick={() => onSave(recordId, editInputRef.current.value)}
          disabled={submitting || !isValueChanged}
        >
          ✓
        </button>
        <button 
          className="employee-balance-cancel-btn"
          onClick={onCancel}
          disabled={submitting}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default InlineBalanceEdit; 